// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3p5Df","close":"styles_close__8Yy8G"};